import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchy4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hierarchy-4" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,18.748h0a6.291,6.291,0,0,1,6.545-6h3.41a6.291,6.291,0,0,1,6.545,6h0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 6.748,
			x2: 12,
			y2: 18.748
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 3.748,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 3.75,
			cy: 20.998,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 20.998,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 20.25,
			cy: 20.998,
			r: 2.25
		})
	]
});
export default SvgHierarchy4;
